import React from "react";
import { Grid, Card, CardHeader, CardContent, TextField } from "@mui/material";
import { AccountBalance as AccountBalanceIcon } from "@mui/icons-material";
import { teal } from "@mui/material/colors";

const RoomLimitsSettings = ({ settings, onSettingChange }) => {
  const roomLimitsSettings = settings.roomLimits;

  const handleInputChange = (key, value) => {
    const processedValue = parseInt(value) || 0;
    console.log(`Updating room limits ${key} to:`, processedValue);
    onSettingChange("roomLimits", key, processedValue);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card elevation={3}>
          <CardHeader
            avatar={<AccountBalanceIcon sx={{ color: teal[500] }} />}
            title="Room Limits & Restrictions"
            subheader="Configure room creation and participation limits"
            sx={{ bgcolor: teal[50] }}
          />
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Standard Admin Room Creation Count"
                  type="number"
                  value={
                    roomLimitsSettings.standard_admin_room_creation_count || ""
                  }
                  onChange={(e) =>
                    handleInputChange(
                      "standard_admin_room_creation_count",
                      e.target.value
                    )
                  }
                  helperText="Number of rooms standard admins can create"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Max Room Duration (Hours)"
                  type="number"
                  value={roomLimitsSettings.max_room_duration_hours || ""}
                  onChange={(e) =>
                    handleInputChange("max_room_duration_hours", e.target.value)
                  }
                  helperText="Maximum duration for any room"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Max Participants Per Room"
                  type="number"
                  value={roomLimitsSettings.max_participants_per_room || ""}
                  onChange={(e) =>
                    handleInputChange(
                      "max_participants_per_room",
                      e.target.value
                    )
                  }
                  helperText="Maximum users allowed in a single room"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Max Teams Per Room"
                  type="number"
                  value={roomLimitsSettings.max_teams_per_room || ""}
                  onChange={(e) =>
                    handleInputChange("max_teams_per_room", e.target.value)
                  }
                  helperText="Maximum teams allowed in a single room"
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default RoomLimitsSettings;
